module.exports = __webpack_public_path__ + "img/energy.19306d43.png";